export enum ApiPaths {
    // Auth
    SIGN_IN = "auth/login",
    SIGN_UP = "auth/register",
    REFRESH_TOKEN = "auth/refresh-token",
    CONFIRM_USER = "auth/activate",
    GOOGLE_LOGIN = "auth/google",

    FORGOT_PASSWORD = "auth/forgot-password",

    // Analytics
    GET_ANALYTICS = "analytics",

    // Forms
    GET_FORMS = "/dashboard/forms",

    /* OAuth */

    CHECK_PARAMS = "/oauth2/authorize",
    CHECK_USER = "/oauth2/check",
    GET_REDIRECT_URL = "/oauth2/auth",
}
